<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      v-model="isOpen"
      width="500">
      <v-card>
        <v-card-title>
          Enviar orden por email
        </v-card-title>
        <v-form v-model="isValid" ref="send">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12>
                <v-text-field
                  v-model="form.email"
                  label="Email"
                  :rules="rules.email"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            outlined
            small
            depressed
            @click="closeDialog">
            {{ $t('ctas.close') }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            dark
            small
            depressed
            @click="send">
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        name: null
      },
      rules: {
        email: [
          v => !!v || this.$t('validations.email.required'),
          v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
        ]
      }
    }
  },
  methods: {
    openDialog () {
      const vm = this
      setTimeout(() => { vm.isOpen = true })
    },
    closeDialog () {
      this.isOpen = false
      this.form = {
        email: null
      }
      this.$refs.send.resetValidation()
    },
    async send () {
      this.$refs.send.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          this.$api.post(`/v1/orders/${this.order}/forward`, {
            email: this.form.email,
            sentBy: this.$store.state.login.user.email
          })
          this.$toasted.show('El correo se envió correctamente', { duration: 5000, type: 'success' })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.closeDialog()
      }
    }
  }
}
</script>
